import React, { useState } from 'react';
import { featuredTestimonials, moreTestimonials, type Testimonial } from '../data/content';
import { SectionTitle } from './SectionTitle';
import { Stars } from './Stars';
import { Accordion } from './Accordion';
import { CtaButton } from './CtaButton';
import { ReviewForm } from './ReviewForm';
const accents = ['bg-blush', 'bg-sky', 'bg-sage', 'bg-lilac'];
const initials = (name: string) => name.replace('.', '').split(' ').map(part => part[0]).join('').slice(0, 2).toUpperCase();
function TestimonialCard({
  testimonial,
  accent
}: {
  testimonial: Testimonial;
  accent: string;
}) {
  return <article className="flex h-full overflow-hidden rounded-2xl border border-line bg-white" data-id="element-130" data-mp="1427xpsb5u6ay">
      <span aria-hidden="true" className={`w-1.5 shrink-0 ${accent}`} data-id="element-131" data-mp="181zznm61te7c" />
      <div className="flex flex-1 flex-col px-6 py-6" data-id="element-132" data-mp="2yfgxgsdwmdg0">
        <div className="flex items-center gap-3" data-id="element-133" data-mp="2yfpemwh284x0">
          <span aria-hidden="true" className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-full font-sans text-[14px] font-bold text-ink ${accent}`} data-id="element-134" data-mp="32haw6v4jh7dj">
            {initials(testimonial.name)}
          </span>
          <div className="min-w-0" data-id="element-135" data-mp="2q1gbay6gff5j">
            <p className="font-sans text-[15px] font-bold text-ink" data-id="element-136" data-mp="2q0eyop9siklp">
              {testimonial.name}
            </p>
            <p className="font-sans text-[13px] text-muted" data-id="element-137" data-mp="2zsavlx0544oc">
              {testimonial.location}
            </p>
          </div>
          <Stars className="ml-auto" data-id="element-138" data-mp="2c1x2e35tjzs6" />
        </div>

        <blockquote className="mt-5 font-sans text-[16px] italic leading-relaxed text-ink-soft" data-id="element-139" data-mp="2c4t29x188yj9">
          “{testimonial.text}”
        </blockquote>

        <p className="mt-auto pt-5 font-sans text-[13px] text-muted" data-id="element-140" data-mp="2m162ldra2amz">
          {testimonial.date}
        </p>
      </div>
    </article>;
}
export function TestimonialsSection() {
  const [showAll, setShowAll] = useState(false);
  return <section className="bg-white px-5 py-10 sm:px-8 lg:py-14" data-id="element-141" data-mp="18u7mcpmb10g">
      <div className="mx-auto w-full max-w-content" data-id="element-142" data-mp="3shrjchctexe8">
        <SectionTitle className="uppercase" data-id="element-143" data-mp="3sjb2cfpuvmjp">
          Quienes aplicaron esta guía nos recomiendan
        </SectionTitle>

        <div className="mt-6 grid gap-4 lg:grid-cols-2" data-id="element-144" data-mp="8dlmwxqkdc9u">
          {featuredTestimonials.map((testimonial, i) => <TestimonialCard key={testimonial.name} testimonial={testimonial} accent={accents[i % accents.length]} data-id="element-145" data-mp="dd81bai4oyk8" data-mpi={i} />)}
        </div>

        {!showAll ? <div className="mx-auto mt-8 max-w-[460px]" data-id="element-146" data-mp="ibj8tekyawza">
            <CtaButton variant="outline" label={`Ver más reseñas (${moreTestimonials.length} historias más)`} sublabel="Conocé cómo fue la experiencia de otras personas" onClick={() => setShowAll(true)} data-id="element-147" data-mp="3gu6z0nehslh6" />
          </div> : <div className="mt-8 space-y-3" data-id="element-148" data-mp="3qrl1tk7htbr0">
            {moreTestimonials.map((testimonial, i) => <Accordion key={testimonial.name} id={`review-${i + 1}`} defaultOpen={i === 0} openClassName="bg-cream" header={<span className="flex items-center gap-3" data-id="element-150" data-mp="2y3z1cktkan8d">
                    <span aria-hidden="true" className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full font-sans text-[13px] font-bold text-ink ${accents[i % accents.length]}`} data-id="element-151" data-mp="2y1crufn41xni">
                      {initials(testimonial.name)}
                    </span>
                    <span className="min-w-0" data-id="element-152" data-mp="1g62fyluitg0n">
                      <span className="block font-sans text-[15px] font-bold text-ink" data-id="element-153" data-mp="1b67ooh6u2of2">
                        {testimonial.name}
                      </span>
                      <span className="block font-sans text-[13px] text-muted" data-id="element-154" data-mp="1674nx8xvz4cw">
                        {testimonial.location}
                      </span>
                    </span>
                  </span>} data-id="element-149" data-mp="3vj34ccp5zke3" data-mpi={i}>
                <blockquote className="font-sans text-[16px] italic leading-relaxed text-ink-soft" data-id="element-155" data-mp="wfguj2hrrd8s">
                  “{testimonial.text}”
                </blockquote>
                <p className="mt-4 font-sans text-[13px] text-muted" data-id="element-156" data-mp="ni6gj9dkha06">
                  {testimonial.date}
                </p>
              </Accordion>)}
          </div>}

        <div className="mt-8" data-id="element-157" data-mp="di7abj4mdvqh">
          <ReviewForm data-id="element-158" data-mp="dk0gyyf8gfyh" />
        </div>
      </div>
    </section>;
}